import { auth } from "@/config/firebase";
import axios from "axios";
import { app, tokens } from "Config/config";

async function requestAxios(requestData, setToken = false) {
  let token;

  if (setToken) {
    token = tokens[0];
  } else {
    token = await auth.currentUser?.getIdToken(true);
    if (!token) throw new Error("No token for this user");
  }

  requestData.headers = { Authorization: `Bearer ${token}`, ...requestData.headers };
  if (process.env.NODE_ENV === "development") {
    requestData.url = `http://localhost:5001/${app.projectId}/us-central1${requestData.url}`;
  }

  return axios(requestData);
}

export default requestAxios;
